/**
 * Leasing Applicants — boundary contract schemas.
 *
 * Owned here, not beside the route: `apps/api/src/routes/manager/leasing-applicants.routes.ts`
 * imports this to register the route, and `apps/landlord/src/lib/leasing.api.ts` derives its
 * `SendApplicationLinkResponse` / `UnreviewedApplicationsCountResponse` types from the same
 * objects. See packages/api-types/README.md.
 *
 * Covers:
 *   POST /landlord/api/leads/:id/send-application-link
 *   GET  /landlord/api/applications/unreviewed/count
 */
import { z } from 'zod';
export const SendApplicationLinkResponseSchema = z.object({
    applyUrl: z.string(),
    expiresAt: z.string(),
});
// GET /landlord/api/applications/unreviewed/count
//
// Scalar count for the Applications-tab nav badge (leasing-support/BR-38).
export const GetUnreviewedApplicationsCountResponseSchema = z.object({
    count: z.number().int().nonnegative(),
});
//# sourceMappingURL=applicants.js.map